import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { noAuthGuard } from '../guards/no-auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { CartComponent } from './cart/cart.component';
import { CatalogComponent } from './catalog/catalog.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { HomeComponent } from './home/home.component';
import { SearchComponent } from './search/search.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'busqueda', component: SearchComponent },
  { path: 'catalogo', component: CatalogComponent },
  { path: 'login', component: LoginComponent, canActivate: [noAuthGuard] },
  { path: 'registro', component: RegisterComponent, canActivate: [noAuthGuard] },
  { path: 'carrito', component: CartComponent },
  { path: 'pago', component: CheckoutComponent, canActivate: [authGuard] },
  {
    path: 'pago/confirmacion',
    canActivate: [authGuard],
    loadChildren: () => import('./payment-confirmation/payment-confirmation.module').then((m) => m.PaymentConfirmationModule)
  },
  { path: 'pedidos', redirectTo: '/mi-cuenta/pedidos', pathMatch: 'full' },
  {
    path: 'mi-cuenta',
    canActivate: [authGuard],
    loadChildren: () => import('./account/account.module').then((m) => m.AccountModule)
  },
  {
    path: 'pedido/:orderId',
    canActivate: [authGuard],
    loadChildren: () => import('./order-detail/order-detail.module').then((m) => m.OrderDetailModule)
  },
  {
    path: 'producto',
    loadChildren: () => import('./product-detail/product-detail.module').then((m) => m.ProductDetailModule)
  },
  {
    path: 'terminos',
    loadChildren: () => import('./terms/terms.module').then((m) => m.TermsModule)
  },
  {
    path: 'nosotros',
    loadChildren: () => import('./nosotros/nosotros.module').then((m) => m.NosotrosModule)
  }
];
